import { ColDef } from "ag-grid-community";

export const defaultColDef: ColDef = {
    flex: 1,
    resizable: true,
    suppressFillHandle: true,
    suppressMenu: true,
    sortable: false,
    unSortIcon: true,
    menuTabs: [],
    wrapHeaderText: true,
    suppressMovable: true,
    editable: false
};

export const formatFileSize = (fileSize: number) => {
    // (fileSize / 1024).toFixed(2) + ' kB';
    // We are getting file size in bytes, so we need to convert it to KB, MB, etc.
    const sizes = ['bytes', 'kB', 'MB', 'GB', 'TB'];
    if (fileSize === 0) return '0 byte';
    const i = Math.floor(Math.log(fileSize) / Math.log(1024));
    return (fileSize / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
}